module.exports = __webpack_public_path__ + "0185eeef017d3e742327a5dc4e230cda.fbx";